const styles = theme => ({
  progress: {
    position: "absolute",
    right: "20%"
  },

  nextButton: {
    width: "50%",
    height: "60px",
    backgroundColor: theme.palette.primary.default,
    color: "#fff!important",
    "&:hover": {
      backgroundColor: theme.palette.primary.default
    }
  },
  backButton: {
    width: "50%",
    height: "60px",
    backgroundColor: "#fff",
    color: theme.palette.primary.light,
    "&:hover": {
      backgroundColor: "#fff"
    }
  },
  haveAnAccountText: {
    fontSize: "10px"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Register/styles.js